import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-tabs', 'selectTab', 'Pasirinkite skirtuką');
Labels.set('ui-tabs', 'left', 'Slinkite į kairę');
Labels.set('ui-tabs', 'right', 'Slinkite į dešinę');
